<template>
  <div>
    <div
      v-for="(category, index) in categories"
      :key="index"
      class="border border-blue- rounded-md p-3 my-2"
    >
      <v-text-field
        v-model="category.categoryName"
        label="Category Name"
        required
        :disabled="!!isUploadCase"
      >
        <template v-slot:append>
          <v-icon
            color="red"
            class="mb-0.5"
            size="20"
            :disabled="!!isUploadCase"
            @click="removeCategory(index)"
          >
            mdi-delete-outline
          </v-icon>
        </template>
      </v-text-field>
      <v-combobox
        v-model="category.options"
        multiple
        chips
        small-chips
        label="Options (Press enter to create new)"
        :disabled="!!isUploadCase"
        @change="updateOptionsVisibility(index)"
      >
        <template v-slot:selection="{ item }">
          <v-chip>
            {{ item }}
            <v-icon
              class="ml-2"
              :color="getVisibility(index, item) ? 'green' : 'red'"
              @click="toggleVisibility(index, item)"
            >
              {{ getVisibility(index, item) ? "mdi-eye" : "mdi-eye-off" }}
            </v-icon>
            <span class="ml-2 text-xs">
              Amount visibility {{ getVisibility(index, item) }}
            </span>
          </v-chip>
        </template>
      </v-combobox>
      <div v-if="category.options.length && availableTemplates.length">
        <v-expansion-panels flat class="border border-gray-300 rounded-md">
          <v-expansion-panel>
            <v-expansion-panel-header
              ><span class="font-semibold text-gray-700"
                >Linked Whatsapp Templates</span
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <div
                class="flex flex-col py-4 gap-4 border border-gray-200 rounded-md px-3 my-1.5"
              >
                <div
                  v-for="(option, optionIndx) in category.options"
                  :key="optionIndx"
                  class="flex items-center justify-between"
                >
                  <p class="text-sm mb-0 ml-4">
                    Option: <span class="font-bold">{{ option }}</span>
                  </p>
                  <div class="ml-2 w-48">
                    <SelectComponent
                      :items="availableTemplates"
                      v-model="category.assignedTemplates[option]"
                      itemText="name"
                      itemValue="templateId"
                    />
                  </div>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
    <div class="flex justify-end my-2">
      <v-btn
        @click="addCategory"
        :color="$vuetify.theme.currentTheme.primary"
        small
        depressed
        elevation="2"
        :disabled="!!isUploadCase"
        class="white--text"
        >Add Category</v-btn
      >
    </div>
  </div>
</template>

<script>
import SelectComponent from "@/components/UI/Select.vue";

export default {
  name: "CaseOutcomeStatus",
  components: { SelectComponent },
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    addCategory: {
      type: Function,
      default: () => {},
    },
    removeCategory: {
      type: Function,
      default: () => {},
    },
    isUploadCase: Boolean,
  },
  data() {
    return {
      authData: this.$storage.getUniversal("token"),
      userOrg: this.$storage.getUniversal("user"),
      fetchingTemplates: false,
      bindTemplateRes: [],
      whatsappTemplates: [],
      panel: 0,
      eyeState: false,
    };
  },
  computed: {
    availableTemplates() {
      const savedTObj = this.bindTemplateRes.reduce((acc, curr) => {
        acc[curr.templateName] = curr;
        return acc;
      }, {});

      const templates = this.whatsappTemplates.map((curr) => {
        const template = savedTObj[curr.name];
        const templateTxt = curr.components.find((c) => c.type === "BODY").text;
        return {
          ...curr,
          params: template?.params || [],
          templateTxt,
          templateId: template?._id,
        };
      }, []);

      const availableTemplates = templates.filter(
        (t) => t.triggerCategory === "app_template"
      );
      return availableTemplates;
    },
  },
  methods: {
    async getBindedTemplates() {
      const { data } = await this.$axios.get(
        "/workforce/whatsapp/templates/assign",
        {
          headers: {
            Authorization: this.authData.access_token,
          },
        }
      );
      this.bindTemplateRes = data.templates;
    },
    async fetchTemplates() {
      this.fetchingTemplates = true;
      const { data } = await this.$axios.get("/workforce/whatsapp/templates", {
        headers: {
          Authorization: this.authData.access_token,
        },
      });

      this.whatsappTemplates = data.templates.filter((t) => t.name);
      this.fetchingTemplates = false;
    },
    updateOptionsVisibility(categoryIndex) {
      const category = this.categories[categoryIndex];
      category.optionsList = category.options?.map((option) => {
        const existing = category.optionsList?.find(
          (opt) => opt.code === option
        );
        return (
          existing || {
            code: option,
            amountVisibility: false,
          }
        );
      });
    },
    toggleVisibility(categoryIndex, code) {
      const category = this.categories[categoryIndex];
      const option = category?.optionsList?.find((opt) => opt.code === code);
      if (option) {
        option.amountVisibility = !option.amountVisibility;
      }
    },
    getVisibility(categoryIndex, code) {
      const category = this.categories[categoryIndex];
      const option = category?.optionsList?.find((opt) => opt.code === code);
      return option ? option.amountVisibility : false;
    },
  },
  mounted() {
    this.getBindedTemplates();
    this.fetchTemplates();
  },
};
</script>
